import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import './style.scss';

const PolicyModal = ({ show, handleClose}:any) => {

  return (
    <Modal show={show} onHide={handleClose} centered className="PlicyModal">
      <Modal.Header closeButton>
        <Modal.Title>Class Cancellation & No-Show Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="container">
        <p>
          At <strong>Fitpond</strong>, we strive to maintain a fair and seamless experience for both our
          users and partners. By booking a class, you agree to the following cancellation and no-show policy.
        </p>
        
        <h4 className="mt-4">1. Cancellation Window:</h4>
        <ul>
          <li><strong>Free Cancellations:</strong> You can cancel a class booking up to 12 hours before the scheduled start time without any penalty.</li>
          <li><strong>Late Cancellations or No-Shows:</strong> If you cancel within 12 hours of the class start time or do not attend the class, this will be counted as a late cancellation or no-show.</li>
        </ul>

        <h4 className="mt-4">2. Account Blockage for Repeated Violations:</h4>
        <ul>
          <li>If you cancel late or miss a class (no-show) 3 times within a 30-day period, your account will be temporarily blocked from booking any future classes for the foreseeable future.</li>
        </ul>

        <h4 className="mt-4">3. Partner Payments:</h4>
        <ul>
          <li><strong>Fitpond</strong> guarantees payment to partners for all booked classes, regardless of late cancellations or no-shows by users, as long as the class is not canceled by the partner themselves.</li>
        </ul>

        <h4 className="mt-4">4. Special Circumstances:</h4>
        <ul>
          <li>If you face an emergency or unavoidable circumstance, please reach out to customer support. We will assess your situation on a case-by-case basis and aim to provide a fair solution.</li>
        </ul>
      </div>
      </Modal.Body>
    </Modal>
  );
};

export default PolicyModal;
